import { render, staticRenderFns } from "./examRunWx.vue?vue&type=template&id=44f276bc&scoped=true&"
import script from "./examRunWx.vue?vue&type=script&lang=js&"
export * from "./examRunWx.vue?vue&type=script&lang=js&"
import style0 from "./examRunWx.vue?vue&type=style&index=0&id=44f276bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f276bc",
  null
  
)

export default component.exports